module.exports = {
	"articleTitle1": "Best Breakfast: Angelo's ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Angelo's",
	"articleLink1": "https://www.michigandaily.com/section/arts/best-breakfast-angelo%E2%80%99s",
	"articleLink2": "https://www.michigandaily.com/section/bside/boaa-angelos",
	"articleSnippet1": "Apr 5, 2016 ... Every time I've walked up to Angelo's, there's been a line out the door. However, \nthe restaurant keeps things moving and once you're in, you ...",
	"articleSnippet2": "Mar 30, 2017 ... With two picturesque buildings to find your perfect fix, Angelo's caters to any \nbreakfast- or brunch-related necessity.",
	"foodRecommendations": [
		{
			"text": "The omelettes here are to die for.",
			"person": "Erik Forkin"
		}
	],
	"articleTitle2": "Best Breakfast: Angelo's ",
	"address": "1100 Catherine St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170405/kmp.Angelo%27s.4.1.16.003.jpg?itok=M380W_cB",
			"author": "File Photo",
			"caption": ""
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/gallery/public/galleryies/kmp.Angelo%27s.4.1.16.005.jpg?itok=wg33U0rc",
			"author": "Kristina Perkins",
			"caption": "Angelo's serves a variety of foods at its location on Catherine Street and Glen Avenue."
		}
	],
	"position": {
		"lat": 42.282975,
		"lng": -83.735457
	},
	"totalMisc": 1,
	"categories": {
		"bestofaa": 1,
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/angelos.json
// module id = 811
// module chunks = 0